import { Countries, Currencies } from '@constants/enums';

/**
 * Maps country codes to their corresponding currencies
 */
export const COUNTRY_TO_CURRENCY_MAP: Record<Countries, Currencies> = {
  [Countries.USA]: Currencies.USD,
  [Countries.MX]: Currencies.MXN,
  [Countries.COL]: Currencies.COP,
};

/**
 * Gets the currency for a given country code
 * @param countryCode - The country code to get the currency for
 * @returns The corresponding currency for the country
 */
export const getCurrencyByCountry = ({
  countryCode,
}: {
  countryCode: Countries;
}): Currencies => {
  if (!countryCode) return Currencies.USD;

  return COUNTRY_TO_CURRENCY_MAP[countryCode as Countries] || Currencies.USD;
};
